import { ILocale } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";
import { IIndustry } from "ui/shared/models/common";

export interface ITranslationHistoryItem {
  termId: string;
  translationId: string;
  author: string;
  authorName: string;
  action: string;
  committedTime: string;
  industry: string;
  locale: string;
  translation: string;
  definition: string;
}

export interface ITranslationHistoryFilter {
  locales?: ILocale[];
  industries?: IIndustry[];
  data?: ITranslationHistoryFilterData;
}

export interface ITranslationHistoryFilterData {
  currentLocale?: ILocale;
  currentIndustry?: IIndustry;
  pinned: boolean;
}

export interface ITranslationHistoryState {
  termId: string;
  isLoading: boolean;
  notifications: INotification[];
  filter: ITranslationHistoryFilter;
  data?: ITranslationHistoryItem[];
}

export const getInitialTranslationHistoryState = (): ITranslationHistoryState => ({
  termId: "",
  isLoading: false,
  filter: {},
  data: undefined,
  notifications: []
});
